import * as React from 'react';
import { createRoot } from 'react-dom/client';
import useRefreshStore, { RefreshItem } from '../../../stores/refreshStore';
import { useAppStore } from '../../../stores/useAppStore';

const RefreshContainerRoot = () => {
    const { createRefresh } = useRefreshStore();
    const { fetchSession } = useAppStore();
    React.useEffect(() => {

        fetchSession();

        const createRefreshMethod = (item: RefreshItem) => {
            createRefresh(item);
        }

        window.RefreshContainer.createRefresh = createRefreshMethod;
    }, []);

    return <></>;
}

export default RefreshContainerRoot;

// MOUNT/UNMOUNT OK
window.RefreshContainerRoot = function(){
    const divRefreshContainer = document.getElementById('react-refresh-container');
    if(divRefreshContainer && typeof window.RefreshContainer == 'undefined') {
        const root = createRoot(divRefreshContainer);
        root.render(<RefreshContainerRoot />);
        window.RefreshContainer = {
            init: true
        }
    }

}